import {FacilitarAgilizarProcesosMobile} from './FacilitarAgilizarProcesosMobile';
export default FacilitarAgilizarProcesosMobile;